/**
 * Generic slideshow module
 * simply adds previous/current classes
 * which can be used to trigger animations
 *
 * Todo:
 * - better onChange/onAfter mechanism. 
 * - onChange should use animation start callback
 * - onAfter should use animation end callback
 */

module.exports = function ($el, opts) {
  opts = opts || {}
  var slides = opts.slides ? [...opts.slides] : [...$el.children]
  var slidesCycle = GenericCycle(slides)
  
  function clearClasses () {
    slides.forEach($slide => {
      $slide.classList.remove('out', 'in')
    })
  }

  function init () {
    clearClasses()
    if (opts.onChange) {
      opts.onChange({
        current: slidesCycle.currentItem(), 
        next: slidesCycle.nextItem(),
        prev: slidesCycle.prevItem(),
        index: slidesCycle.current()
      })
    }
    slidesCycle.currentItem().classList.add('in')
    return this
  }

  function destroy () {
    clearClasses()
  }

  function next () {
    clearClasses()
    slidesCycle.currentItem().classList.add('out')
    slidesCycle.goNext().classList.add('in')
    if (opts.onChange) {
      opts.onChange({
        current: slidesCycle.currentItem(), 
        next: slidesCycle.nextItem(),
        prev: slidesCycle.prevItem(),
        index: slidesCycle.current()
      })
    }
  }

  function prev () {
    clearClasses()
    slidesCycle.currentItem().classList.add('out')
    slidesCycle.goPrev().classList.add('in')
    if (opts.onChange) {
      opts.onChange({
        current: slidesCycle.currentItem(), 
        next: slidesCycle.nextItem(),
        prev: slidesCycle.prevItem(),
        index: slidesCycle.current()
      })
    }
  }
  
  return {
    init: init,
    destroy: destroy,
    next: next,
    prev: prev,
    data: () => {
      return {
        current: slidesCycle.current(),
        next: slidesCycle.next(),
        prev: slidesCycle.prev(),
        length: slidesCycle.length,
      }
    }
  }
}

/**
 * Generic cycle module for moving
 * through an array
 */

function GenericCycle (list, index) {
  index = index || 0

  var current = () => index
  var next = () => (index + 1 >= list.length) ? 0 : index + 1
  var prev = () => (index - 1 < 0) ? list.length - 1 : index - 1

  var currentItem = () => list[index]
  var nextItem = () => list[next()]
  var prevItem = () => list[prev()]
  
  function goNext () {
    index = next()
    return list[index]
  }

  function goPrev () {
    index = prev()
    return list[index]
  }

  return {
    current,
    next,
    prev,
    currentItem,
    nextItem,
    prevItem,
    goNext,
    goPrev,
    length: list.length
  }
}